var _class, _descriptor, _descriptor2, _messageUnit;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classPrivateFieldGet(receiver, privateMap) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get"); return _classApplyDescriptorGet(receiver, descriptor); }
function _classApplyDescriptorGet(receiver, descriptor) { if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }
function _classPrivateFieldSet(receiver, privateMap, value) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set"); _classApplyDescriptorSet(receiver, descriptor, value); return value; }
function _classExtractFieldDescriptor(receiver, privateMap, action) { if (!privateMap.has(receiver)) { throw new TypeError("attempted to " + action + " private field on non-instance"); } return privateMap.get(receiver); }
function _classApplyDescriptorSet(receiver, descriptor, value) { if (descriptor.set) { descriptor.set.call(receiver, value); } else { if (!descriptor.writable) { throw new TypeError("attempted to set read only private field"); } descriptor.value = value; } }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { Action, MessageUnit, ModalFormat } from '@square/dashboard-protos/models/squareup/messageservice/service';
import Service, { inject as service } from '@ember/service';
import { BUSINESS_BANKING_PLACEMENT_ID } from '@banking/api/services/message-service-api';
var SlideNumber = /*#__PURE__*/function (SlideNumber) {
  SlideNumber[SlideNumber["One"] = 1] = "One";
  SlideNumber[SlideNumber["Two"] = 2] = "Two";
  SlideNumber[SlideNumber["Three"] = 3] = "Three";
  return SlideNumber;
}(SlideNumber || {});
var SupportedLocale = /*#__PURE__*/function (SupportedLocale) {
  SupportedLocale["EN_US"] = "en-us";
  SupportedLocale["ES_US"] = "es-us";
  return SupportedLocale;
}(SupportedLocale || {});
(function (_SupportedLocale) {
  function parse(str) {
    switch (str.toLowerCase()) {
      case 'en':
      case 'en-us':
        return SupportedLocale.EN_US;
      case 'es':
      case 'es-us':
      default:
        return SupportedLocale.ES_US;
    }
    return undefined;
  }
  _SupportedLocale.parse = parse;
})(SupportedLocale || (SupportedLocale = {}));
function getModalImageUrl(localeString, slideNumber) {
  const locale = SupportedLocale.parse(localeString) ?? SupportedLocale.EN_US;
  switch (locale) {
    case SupportedLocale.ES_US:
      {
        switch (slideNumber) {
          case SlideNumber.One:
            return 'https://jumbotron-production-f.squarecdn.com/assets/14379a39d955d31c6129c.png';
          case SlideNumber.Two:
            return 'https://jumbotron-production-f.squarecdn.com/assets/145268f826ea653625e86.png';
          case SlideNumber.Three:
            return 'https://jumbotron-production-f.squarecdn.com/assets/14381920899056c9b8c6d.png';
          default:
            throw new Error('Unhandled SlideNumber value');
        }
      }
    case SupportedLocale.EN_US:
      {
        switch (slideNumber) {
          case SlideNumber.One:
            return 'https://jumbotron-production-f.squarecdn.com/assets/1421965fe64f85a09af18.png';
          case SlideNumber.Two:
            return 'https://jumbotron-production-f.squarecdn.com/assets/14527e42422b0ad797cba.png';
          case SlideNumber.Three:
            return 'https://jumbotron-production-f.squarecdn.com/assets/142217ea0c60571e7db08.png';
          default:
            throw new Error('Unhandled SlideNumber value');
        }
      }
    default:
      throw new Error('Unhandled SupportedLocale value');
  }
  throw new Error('Invariant Error');
}
const MESSAGE_IDS = new Set(['38d1a097-64fc-4302-b4b5-04aef6a58f39', '0b9015c3-fc29-4fff-8ea4-80553d9aa040']);
let SquareCardRelaunchModalService = (_class = (_messageUnit = /*#__PURE__*/new WeakMap(), class SquareCardRelaunchModalService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "messageServiceApi", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _classPrivateFieldInitSpec(this, _messageUnit, {
      writable: true,
      value: undefined
    });
  }
  async messageUnit() {
    const messageUnit = await this.messageServiceApi.peekMessageUnits(BUSINESS_BANKING_PLACEMENT_ID);
    if (messageUnit == null) {
      return undefined;
    }
    if (MESSAGE_IDS.has(messageUnit.messageId)) {
      _classPrivateFieldSet(this, _messageUnit, MessageUnit.Builder.from(messageUnit).modalFormat(this.buildModalFormat()).build());
    }
    return _classPrivateFieldGet(this, _messageUnit);
  }
  async dismiss() {
    if (_classPrivateFieldGet(this, _messageUnit) == null) {
      return;
    }
    await this.messageServiceApi.trackEngagement(BUSINESS_BANKING_PLACEMENT_ID, _classPrivateFieldGet(this, _messageUnit).requestToken, Action.VIEW);
    await this.messageServiceApi.trackEngagement(BUSINESS_BANKING_PLACEMENT_ID, _classPrivateFieldGet(this, _messageUnit).requestToken, Action.DISMISS);
    _classPrivateFieldSet(this, _messageUnit, undefined);
  }
  getPrimaryLocale() {
    return this.intl.primaryLocale;
  }
  buildModalFormat() {
    const slide3TabletBody = `
${this.intl.t('banking.checking.relaunchModal.slide3.body')}
<br>
<br>
<span class="sqcard-relaunch-modal-legal">${this.intl.t('banking.checking.relaunchModal.tos')}</span>
`;
    const ctaNext = new ModalFormat.ModalSlide.CtaNext.Builder().ctaText(this.intl.t('banking.checking.relaunchModal.next')).build();
    return new ModalFormat.Builder().slides([new ModalFormat.ModalSlide.Builder().tabletTitle(this.intl.t('banking.checking.relaunchModal.slide1.title')).tabletBody(this.intl.t('banking.checking.relaunchModal.slide1.body')).tabletImageUrl(getModalImageUrl(this.getPrimaryLocale(), SlideNumber.One)).ctaNext(ctaNext).build(), new ModalFormat.ModalSlide.Builder().tabletTitle(this.intl.t('banking.checking.relaunchModal.slide2.title')).tabletBody(this.intl.t('banking.checking.relaunchModal.slide2.body')).tabletImageUrl(getModalImageUrl(this.getPrimaryLocale(), SlideNumber.Two)).ctaNext(ctaNext).build(), new ModalFormat.ModalSlide.Builder().tabletTitle(this.intl.t('banking.checking.relaunchModal.slide3.title')).tabletBody(slide3TabletBody).tabletImageUrl(getModalImageUrl(this.getPrimaryLocale(), SlideNumber.Three)).ctaNext(new ModalFormat.ModalSlide.CtaNext.Builder().ctaText(this.intl.t('banking.checking.relaunchModal.dismiss')).build()).build()]).build();
  }
}), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "messageServiceApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
export { SquareCardRelaunchModalService as default };